<template>
  <section class="market-home">
    <div class="market-toolbar">
    <a-menu class="market-tabs" mode="horizontal" :selected-keys="[market]" @click="selectMarket">
      <a-menu-item v-for="item in visibleMarkets" :key="item.key">{{ item.label }}</a-menu-item>
    </a-menu>
    <StockSearch />
    </div>

    <ChinaMarket v-if="market === 'cn'" />
    <HongKongMarket v-else-if="market === 'hk'" />
    <USMarket v-else-if="market === 'us'" />
    <IndexMarket v-else-if="market === 'index'" />
    <IndexPredictionMarket v-else-if="market === 'guess'" />
    <section v-else class="market-coming">
      <h2>{{ market === 'us' ? '美股' : '股指交易' }}模块开发中</h2>
      <p>请先选择沪深或港股查看当前可用行情。</p>
    </section>
  </section>
</template>

<script>
import ChinaMarket from './ChinaMarket.vue'
import HongKongMarket from './HongKongMarket.vue'
import USMarket from './USMarket.vue'
import IndexMarket from './IndexMarket.vue'
import IndexPredictionMarket from './IndexPredictionMarket.vue'
import StockSearch from '@/components/StockSearch.vue'
import './marketLayout.css'

import { marketEnabled } from '@/utils/systemConfig'
const marketKeys = ['cn', 'hk', 'us', 'index', 'guess']

export default {
  name: 'MarketHome',
  components: { ChinaMarket, HongKongMarket, USMarket, IndexMarket, IndexPredictionMarket, StockSearch },
  computed: {
    visibleMarkets() { return [{ key:'cn', label:'沪深' }, { key:'hk', label:'港股' }, { key:'us', label:'美股' }, { key:'index', label:'股指交易' }, { key:'guess', label:'股指竞猜' }].filter(item => marketEnabled(item.key)) },
    market() {
      const market = this.$route.params.market
      return marketKeys.includes(market) && marketEnabled(market) ? market : 'cn'
    }
  },
  watch: { market: { immediate: true, handler() { if (!marketEnabled(this.$route.params.market)) this.$router.replace({ name: 'MarketHome', params: { market: 'cn' } }).catch(() => {}) } } },
  methods: {
    selectMarket({ key }) {
      if (marketEnabled(key) && key !== this.market) this.$router.push({ name: 'MarketHome', params: { market: key } })
    }
  }
}
</script>

<style scoped>
.market-home { height: 100%; display: flex; flex-direction: column; min-height: 0; }
.market-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding-right: 16px; flex-shrink: 0; background: var(--theme-header); border-bottom: 1px solid var(--theme-border); }
.market-tabs { flex: 1; min-width: 0; }
.market-toolbar .stock-search { flex-shrink: 0; width: clamp(180px, 24vw, 300px); }
.market-tabs { border-bottom: 1px solid var(--theme-border) !important; }
.market-tabs .ant-menu-item { min-width: 88px; text-align: center; }
.market-coming { min-width: 1100px; min-height: 520px; padding: 120px 20px; color: var(--theme-text); text-align: center; }
.market-coming p { color: var(--theme-muted); }
</style>

<style>
.market-home .market-tabs { background: var(--theme-header); }
.market-home .market-tabs .ant-menu-item { color: var(--theme-label); }
.market-home .market-tabs .ant-menu-item-selected,
.market-home .market-tabs .ant-menu-item-active,
.market-home .market-tabs .ant-menu-item:hover {
  color: var(--theme-text) !important;
  border-bottom: 2px solid var(--theme-text) !important;
}
</style>
